// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","content":"Footer_content__aJpHx","euFlag":"Footer_euFlag__MD8Rq","text":"Footer_text__27sON","rights":"Footer_rights__pTQXT"};